import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Platform } from '@ionic/angular';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';


@Injectable({
  providedIn: 'root'
})
export class VersaoService {

  versao$ = new Subject<string>();

  constructor(private http: HttpClient, private platform: Platform, private appVersion: AppVersion) {
  }

  carregarVersao() {
    if (this.platform.is('hybrid')) {
      this.appVersion.getVersionNumber().then(v => {
        this.versao$.next(v);
      });
    }
    else {
      this.http.get('/assets/version.json').subscribe((res: any) => {
        this.versao$.next(res.versao);
      });
    }

  }
}
